(function () {
  function init(component) {
    if (!component || component.dataset.autoplayInit === "1") return;

    var delay = parseInt(component.dataset.autoplay || "0", 10);
    if (!delay || delay < 1000) return;

    // Respecte l’accessibilité
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;

    var getTabs = function () {
      return Array.prototype.slice.call(component.querySelectorAll('[role="tab"]'));
    };

    var tries = 0;
    var maxTries = 60; // ~6s

    var timer = null;

    function stop() {
      if (timer) {
        clearInterval(timer);
        timer = null;
      }
    }

    function start() {
      stop();
      timer = setInterval(function () {
        var tabs = getTabs();
        if (!tabs.length) return;

        var currentIndex = tabs.findIndex(function (t) {
          return t.getAttribute("aria-selected") === "true";
        });
        if (currentIndex < 0) currentIndex = 0;

        var nextIndex = (currentIndex + 1) % tabs.length;
        tabs[nextIndex].click();
      }, delay);
    }

    function tryBoot() {
      var tabs = getTabs();
      if (tabs.length) {
        component.dataset.autoplayInit = "1";

// Pause uniquement sur interaction utilisateur (pas sur les clics déclenchés par le script)
component.addEventListener("pointerdown", stop, { passive: true });

component.addEventListener("click", function (e) {
  if (e.isTrusted) stop();
});

component.addEventListener("focusin", function (e) {
  if (e.isTrusted) stop();
});


        start();
        return;
      }

      tries += 1;
      if (tries < maxTries) setTimeout(tryBoot, 100);
    }

    tryBoot();
  }

  function initAll(root) {
    (root || document).querySelectorAll("layered-slideshow-component[data-autoplay]").forEach(init);
  }

  // Chargement normal
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  // Theme editor (OS2)
  document.addEventListener("shopify:section:load", function (e) {
    initAll(e.target);
  });
})();